import {
  cnxAPI,
  notifica,
  show_ldr,
  getIdUsuario,
  cnxSeg,
  getToken,
} from "./utils";

import axios from "axios";

const getProfiles = async (_callback) => {
  show_ldr(true);
  let response = await axios.get(`${cnxAPI}System/getProfiles`).then((res) => {
    return res.data;
  });
  show_ldr(false);

  return response.data;
};

const getVistas = async (_callback) => {
  show_ldr(true);
  let response = await axios.get(`${cnxAPI}System/getVistas`).then((res) => {
    return res.data;
  });
  show_ldr(false);

  return response.data;
};

const postSaveVistas = async (dto) => {
  dto.idUsuarioAct = getIdUsuario();
  show_ldr(true);
  const config = {
    headers: {
      "content-type": "multipart/form-data",
    },
  };

  const formData = new FormData();
  Object.keys(dto).forEach(function (item) {
    formData.append(item, dto[item]);
  });

  let response = await axios
    .post(`${cnxAPI}System/saveVista`, formData, config)
    .then((res) => {
      return res.data;
    });
  show_ldr(false);
  return response;
};

const getElementos = async () => {
  let response = await axios.get(`${cnxAPI}System/getElementos`).then((res) => {
    return res.data;
  });
  return response;
};

const getVistasTree = async (id) => {
  let response = await axios
    .get(`${cnxAPI}System/getVistasTree/${id}`)
    .then((res) => {
      return res.data;
    });
  return response;
};

const postPermisos = async (dto) => {
  show_ldr(true);

  let response = await axios
    .post(`${cnxAPI}System/GeneraPermisos`, dto)
    .then((res) => {
      return res.data;
    });
  show_ldr(false);
  return response;
};

const postSaveProfiles = async (dto) => {
  dto.idUsuarioAct = getIdUsuario();
  show_ldr(true);
  let response = await axios
    .post(`${cnxAPI}System/saveProfiles`, dto)
    .then((res) => {
      return res.data;
    });
  show_ldr(false);
  return response;
};
export {
  getProfiles,
  getVistas,
  postSaveVistas,
  getElementos,
  getVistasTree,
  postPermisos,
  postSaveProfiles,
};
